import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const StairsIcon = ({ width = 80, height = 80, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M59.6875 61V19H20.3125V61" stroke={fill} strokeWidth="2" />
            <path d="M59.6875 60H25.5625" stroke={fill} strokeWidth="2" />
            <rect x="47.875" y="36.375" width="11.8125" height="7.875" stroke={fill} strokeWidth="2" />
            <rect x="40" y="44.25" width="19.6875" height="7.875" stroke={fill} strokeWidth="2" />
            <path d="M32.125 52.125H59.6875V60H32.125V52.125Z" stroke={fill} strokeWidth="2" />
        </svg>
    );
};
